import styled, { css } from 'styled-components'

export const StyledTableEffect = css`
  max-height: 4rem;
  border-top: 1px solid ${({ theme }) => theme.colors.GREY_90};
  border-bottom: 1px solid transparent;
  :first-child {
    border-top: 1px solid transparent;
  }
  :last-child {
    border-bottom: 1px solid ${({ theme }) => theme.colors.GREY_90};
    :hover {
      border-bottom: 1px solid transparent;
    }
  }

  :hover {
    + li {
      border-top: 1px solid transparent;
    }
    /* should migrate rows to LI element */
    + div {
      border-top: 1px solid transparent;
    }
    background-color: ${({ theme }) => theme.colors.GREY_30};
    border-radius: 4px;
    border-top: 1px solid transparent;
    border-bottom: 1px solid transparent;
  }
`

// NOTE: the styled instances below are to be used with the tanstack table
// instances
export const Table = styled.table<{
  hasLastTrBorderBottom: boolean
  hasBorderBottom: boolean
  isRowClickable: boolean
}>`
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;

  tr:first-child {
    td {
      border-top: 1px solid transparent;
    }
  }

  tr:last-child {
    td {
      border-bottom: ${({ theme, hasLastTrBorderBottom }) =>
        `1px solid ${
          hasLastTrBorderBottom ? theme.colors.GREY_90 : 'transparent'
        }`};
      &:hover: {
        background-color: pink;
        border-bottom: 1px solid transparent;
      }
    }
  }

  tr {
    td {
      border-top: ${({ theme, hasBorderBottom }) =>
        `1px solid ${hasBorderBottom ? theme.colors.GREY_90 : 'transparent'}`};
    }
    &:hover {
      background-color: ${({ theme }) => theme.colors.GREY_30};
      cursor: ${({ isRowClickable }) => (isRowClickable ? 'pointer' : 'unset')};
      td {
        border-top: 1px solid transparent;
        border-bottom: 1px solid transparent;
      }
      td:first-child {
        border-radius: 4px;
      }
      td:last-child {
        border-radius: 4px;
      }
    }
  }
`

export const TableRowHeader = styled.tr`
  position: sticky;
  top: 0;
`
